import {
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import {
  DisplayFormErrors,
  DrawerFooterContent,
  VerticalForm,
} from "melco-shared-logic";
import { Drawer as DrawerType } from "../../../../hooks/drawer/useGenericDrawer";
import { DisplayProductVersionsDropDown } from "../../../dropdown/DisplayProductVersionsDropDown";
import { DisplayBlankDropDown } from "../../../dropdown/DisplayBlankDropDown";
import { DisplayLevelSubscriptionDropDown } from "../../../dropdown/DisplayLevelSubscriptionDropDown";
import { useState } from "react";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const AlertWrapper = styled.div`
  margin-bottom: 25px;
`;

const { spacings } = DesignTokens;

type DisplayUpgradeLicenseVersionAndLevelProps = {
  referenceDrawer?: DrawerType;
  stepback: any;
  currentLicense: any;
  callBackForVersionDisplayValue: any;
  callBackForSubscriptionCodeDisplayValue: any;
  licenseFormValues: any;
};

export const DisplayUpgradeLicenseVersionAndLevel: React.FC<
  DisplayUpgradeLicenseVersionAndLevelProps
> = ({
  stepback,
  licenseFormValues,
  currentLicense,
  callBackForSubscriptionCodeDisplayValue,
  callBackForVersionDisplayValue,
}) => {
  const { t } = useTranslation();
  const { submitForm } = useFormikContext();

  const [selectedVersionValue, setSelectedVersionValue] = useState();

  const callBackForVersion = (options: any) => {
    /**
     * We have to use dropdown label as version value
     * because the api products/subscriptions takes version_number_list as a version number
     * This is version object  
     * {
            "id": "PVR-1",
            "version_number": "12",
            "created_date": "2023-11-07T19:51:55.04Z"
        }
 
        While Create new License we have to use id like PVR-1
        While we have to search for subscriptions (Level)  we have to use 12
 
        
          */

    setSelectedVersionValue(options.label);
    callBackForVersionDisplayValue(options.label);
    //setCreateConfirmDetailsToDisplay({ ...createConfirmDetailsToDisplay, version_number_label: v.label })
  };

  const callBackForSubscription = (v: any, options: any) => {
    callBackForSubscriptionCodeDisplayValue(options.label);
  };

  return (
    <>
      <div>
        <AlertWrapper>
          <DisplayFormErrors />
        </AlertWrapper>

        <FullWidthSpace direction="vertical" size="middle">
          <div>
            <Title level={4}>
              {t("licensemanager.upgrade.form.licensedetail")}
            </Title>

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.melco_customer_id")}
                    content={currentLicense.melco_customer_id}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.product")}
                    content={currentLicense.product_name}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />

                  <LabeledItem
                    label={t("licensemanager.upgrade.form.version")}
                    content={currentLicense.version_number}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />

                  {/* <LabeledItem
                    label={t("licensemanager.upgrade.form.level")}
                    content={currentLicense.subscription_code}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  /> */}
                </Space>
              </Col>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.email")}
                    content={currentLicense.email_address}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />

                  <LabeledItem
                    label={t("licensemanager.create.form.dont_assign_license")}
                    content={
                      licenseFormValues?.assign_license
                        ? t("common.yes")
                        : t("common.no")
                    }
                    fallback={t("global.fallback.empty")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.level")}
                    content={currentLicense.subscription_code}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                </Space>
              </Col>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.serial_number")}
                    content={currentLicense.serial_number}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.language")}
                    content={
                      currentLicense.language != ""
                        ? t(`language.${currentLicense.language}` as any)
                        : ""
                    }
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                </Space>
              </Col>
            </Row>
          </div>
          <div>
            <VerticalForm>
              <Title level={4}>
                {t("licensemanager.upgrade.form.version&level")}
              </Title>
              {currentLicense.product_code && (
                <DisplayProductVersionsDropDown
                  selectedProductValue={currentLicense.product_code}
                  callbackFn={callBackForVersion}
                />
              )}

              {currentLicense.product_code && selectedVersionValue ? (
                <DisplayLevelSubscriptionDropDown
                  selectedProductValue={currentLicense.product_code}
                  selectedVersionValue={selectedVersionValue}
                  callbackFn={callBackForSubscription}
                />
              ) : (
                <DisplayBlankDropDown
                  name="subscription_code"
                  label={t("licenses.basic.search.level.title")}
                />
              )}
            </VerticalForm>
          </div>
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("licensemanager.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                >
                  {t("licensemanager.buttons.next")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </div>
    </>
  );
};
